import { html } from 'lit';
const { isEmpty, htmlEntities } = _uo.utility;

/**
 * Wraps text inside curly brackets inside
 *
 * @param {String} text The text
 * @return {TemplateResult|undefined} The template with the text parsed
 */
const bracketsToStrong = ( text ) => {
	if ( isEmpty( text ) ) {
		return;
	}

	// Decode the sentence. Lit will take care of the sanitization
	const sentence = htmlEntities.decode( text );

	// Divide the input into potential pill segments and plain text segments
	const segments = sentence.split( '{{' );

	return html`
		<span>
			${
				// Transform each segment based on its content
				segments.map( segment => {
					// Check if the segment contains a pill by looking for "}}"
					const parts = segment.split( '}}' );

					// If the segment is plain text, wrap it with the appropriate span and class
					// Otherwise, wrap it around a strong tag
					return parts.length === 1 ? parts[0] : html`<strong>${ parts[0] }</strong>${ parts[1] }`;
				} )
			}
		</span>
	`;
}

export default bracketsToStrong;
